import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { addQuestion } from '../services/surveyService'; // Ensure this service is imported
import './AddQuestion.css';

const AddQuestion = ({ surveyId, sectionIndex, onUpdate, onClose }) => {
  const [comment, setComment] = useState(''); // Initialize comment state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate input
    if (!comment.trim()) {
      setError('Please provide a comment to generate a question.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Prepare payload for the backend
      const payload = {
        sectionIndex,
        comment,
      };

      // Call the addQuestion service
      const response = await addQuestion(surveyId, payload);

      // Handle successful response
      if (response.success) {
        onUpdate(response.data.newQuestion); // Pass new question to parent
        setComment(''); // Clear input field
        onClose(); // Close the Add Question modal
      } else {
        setError(response.message || 'Failed to add question. Please try again.');
      }
    } catch (err) {
      // Handle errors gracefully
      setError(err.response?.data?.message || 'Failed to generate a question. Please try again.');
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="add-question-container">
      <h4>Add a New Question</h4>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <textarea
          id="commentary"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Provide details about the question you'd like to add"
          required
        />
        <div className="button-group">
          <button type="submit" disabled={loading} className="generate-button">
            {loading ? 'Generating...' : 'Generate Question'}
          </button>
          <button
            type="button"
            className="cancel-button"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

AddQuestion.propTypes = {
  surveyId: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddQuestion;
